
<template>
    <div class="row">
        <div class="col-lg-12 mb-3">
            <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
            <b-card :header="$t('general.projects.title')" header-tag="h3" class="bg-default-card">
                <div class="row">
                    <div class="float-left ml-3">
                        <label>{{$t('table.filter_by_status')}}</label>
                        <select class="form-control selectByStatus" v-model="filterByStatus" @change="onFilterByStatus">
                            <option :value="''">{{$t('misc.all')}}</option>
                            <option v-for="status in statuses" :value="status.code" :key="status.code">{{status.name}}</option>
                        </select>
                    </div>
                </div>

                <data-table
                    v-if="tableLoaded"
                    :exportable = "false" title=""
                    :rows="getData.rowData"
                    :columns="columnData"
                    :perPage="perPage"
                    :rowsCount="rowsCount"
                    :currentPage="currentPage"
                    :pageCount="pageCount"
                    @clickSpecificRow="onViewRow2"
                    @rowClickDelete="onDeleteRow"
                    @rowClickEdit="onEditRow"
                    @rowClickHourGlass="onHourGlass"
                    @changePage="changePage"
                    @searchEvent="searchEvent"
                    @orderByEvent="orderByEvent"
                    >
                </data-table>
                
                <b-btn class="btn btn-default mt-3" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project'], ['create'])"><i class="fa fa-plus-circle mr-1"></i> {{$t('general.projects.create_button')}}</b-btn>
            </b-card>

            <div class="row">
                <div class="col-sm-12">
                    <span v-if="this.$store.getters.hasPermission(['project_milestones'], ['read']) && getData.rowData.length > 0">
                        <i class="fa fa-2x fa-hourglass-end text-dark"></i> - {{$t('general.buttons.milestones')}}
                    </span>
                </div>
            </div>

            <project-modal :model.sync="model" ref="projectModal" @done="done" :title="actionTitle"></project-modal>

            <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
                {{ $t('messages.delete') }}
            </confirm-dialog>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import VueForm from "vue-form";
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import http from '@/libs/http';
import miniToastr from 'mini-toastr';
import PlusButton from '@/components/global/miscellaneous/PlusButton.vue';

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import Multiselect from 'vue-multiselect';

import ProjectModal from '@/components/global/modals/ProjectModal.vue';

Vue.component(Multiselect);

export default {
    name: 'projects',
    components: {
        DataTable,
        flatPickr,
        ConfirmDialog,
        notificationIcons,
        Multiselect,
        PlusButton,
        ProjectModal,
    },
    data() {
        return {
            milestones: ['dump'],
            contractors: 1,
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title'),
                    active: true
                }
            ],
            tableName: 'project',
            tableNameTranslated: Vue.i18n.translate('general.projects.title_modal'),
            isLoading: false,
            searchText: '',
            disciplineIds: [],
            row: {},
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            currentPage: 1,
            pageCount: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            filterByStatus: '',
            selectedProject: {},

            actionTitle: '',
            getData: {
                rowData: [],
                getDisciplines: {
                    fromMain: [],
                    fromGeneral: [],
                    all: []
                },
                getFinalClients: [],
                getClients: [],
                getProjects: []
            },
            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '130px',
                    showDeleteButton: true,
                    showHourGlassButton: true,
                    showEditButton: true,
                },
                {
                    label: Vue.i18n.translate('table.project_name'),
                    width: '200px',
                    field: 'name',
                    numeric: false,
                    html: false,
                    clickable: true,
                },
                {
                    label: Vue.i18n.translate('table.status'),
                    field: 'statusV',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.seller_company'),
                    field: 'seller_name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.construction_company_name'),
                    field: 'construction_company_name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.site_location_name'),
                    field: 'site_location_name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.site_location_address'),
                    field: 'site_location_address',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.contractor_name'),
                    field: 'contractor_name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.final_client_name'),
                    field: 'final_client_name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.start_date'),
                    field: 'start_date',
                    width: '105px',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.end_date'),
                    field: 'end_date',
                    width: '105px',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.created_by_user'),
                    field: 'user.fullname',
                    numeric: false,
                    html: false,
                },
            ],
            model: {}
        }
    },
    mounted () {
        this.getClients();
        this.onLoadTable();
        this.updateMenuProjects();

        if(this.$store.state.came_from_url == 'companies') {
            var projects = this.$store.state.go_back_data_list['projects'];
            this.model = projects.model;

            this.$refs.projectModal.__loadCompanies({
                selectedCompany: projects.selectedCompany,
                selectedMainPM: projects.selectedMainPM,
                selectedMainCM: projects.selectedMainCM,
                selectedCompany2: projects.selectedCompany2,
                selectedGeneralPM: projects.selectedGeneralPM,
                selectedGeneralCM: projects.selectedGeneralCM,
                selectedCompany3: projects.selectedCompany3,
                selectedFinalPM: projects.selectedFinalPM,
                selectedFinalCM: projects.selectedFinalCM,
                selectedCompany4: projects.selectedCompany4
            });

            delete this.$store.state.go_back_data_list['projects'];

            this.$store.state.go_back_url = null;
            this.$store.state.came_from_url = null;
            this.$refs.projectModal.show();
        }
    },
    computed: {
        statuses: {
            get: function () {
                let statuses = this.$store.getters.getProjectStatuses;
                return statuses;
            }
        }
    },
    watch: {
        statuses: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    methods: {
        updateMenuProjects() {
            this.$store.dispatch('getUserProjects', {page: 1}).then(res => {
                if (!res.isError) {
                    this.$store.commit('SET_USER_PROJECTS', res);
                }
            });
        },
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        infoMsg(msg) {
            miniToastr.info(msg, Vue.i18n.translate('messages.info'), 4000);
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        onFilterByStatus () {
            this.onLoadTable();
            this.infoMsg(Vue.i18n.translate('messages.table_filtered'));
        },
        onLoadTable () {
            let data = http.route(this.tableName + '?search=' + this.searchInput + '&filters[status]=' + this.filterByStatus + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get();
            data.then(response => {
                if (!response.isError) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;

                    var data = response.data;
                    data.forEach(field => {                    
                        field.companies.forEach(field2 => {
                            if (field2.pivot.type == 'main') {
                                field.construction_company_name = field2.name;
                            }
                            if (field2.pivot.type == 'general') {
                                field.contractor_name = field2.name;
                            }
                            if (field2.pivot.type == 'final') {
                                field.final_client_name = field2.name;
                            }

                            if (typeof this.statuses[field.status] != 'undefined') {
                                field.statusV = this.statuses[field.status].name;
                            }
                        });
                    });

                    this.getData.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        cleanModel () {
            this.row = null;
            this.model = {};
            this.$refs.projectModal.clear();
        },
        onHourGlass (row) {
            this.$router.push({name: 'milestones', params: {id: row.id}});
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.cleanModel();
            this.$refs.projectModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.$refs.projectModal.loadVals(row);
            this.$refs.projectModal.show();
        },
        onViewRow2 (row, index) {
            this.$store.commit('SET_CURRENT_PROJECT', row);
            this.$router.push('/project/' + row.id);
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if(response.isError == false) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                        this.onLoadTable();
                        this.updateMenuProjects();
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModal.hide();
        },
        update(disciplines) {
            let disciplineIds = [];

            this.model.disciplines.forEach((discipline) => {
                disciplineIds.push(discipline.id)
            });

            this.disciplineIds = disciplineIds;
        },
        getClients () {
            let data = http.route('company').get();
            data.then(response => {
                if (!response.isError) {
                    this.getData.getClients = response.data;
                }
            });
        },
        onViewMilestoneRow(row, index) {
            this.$router.push({name: 'milestones', params: {id: row.id}});
        },
        done(type) {
            this.onLoadTable();
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    .multiselect-custom {
        width: 300px !important;
        height: 40px !important;
    }
    .multiselect__input:focus {
        width: 100% !important;
    }
    .multiselect__input {
        max-width: 100% !important;
    }
    .selectByStatus {
        width: 200px !important;
    }
    select {
        -webkit-appearance: menulist-button;
        -moz-appearance: menulist-button;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/project/projects/projects.vue